/**
 * Labstep
 *
 * @module components/Comment/Action/Delete
 * @desc Comment Delete action
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { CommentActionDeleteProps } from './types';

export const CommentActionDelete: React.FC<
  CommentActionDeleteProps
> = ({ comment }) => (
  <EntityActionDelete
    // FIXME Removing any mention to entityName ('comment') because of notes
    humanReadableName=" "
    entity={comment}
  />
);
